<template lang="pug">
app-entity(
  @close="$emit('close', instance)",
  v-bind="{ ...$props, selector: false }",
  :path="path",
  :entity="$findEntity('OrderLine')",
  :replasable="false",
  :selector="false",
)
  template(v-slot:addFields)
    v-row
      v-col(cols="3")
        v-select(
          :label="$t('OrderLine.status')",
          v-model="status",
          :items="statusList",
          item-text='name',
          item-value='id',
          return-object,
        )
      v-col
        v-text-field(
          :value="instance.bundleKey",
          :label="$t('OrderLine.bundleKey')",
          disabled,
        )
      v-col
        v-text-field(
          v-model="instance.unitPrice",
          :label="$t('OrderLine.unitPrice')",
          type="number",
          step="0.01",
          placeholder=" "
        )
      v-col
        v-autocomplete(
          :label="$t('OrderLine.currency')",
          :items="currencies",
          :item-text="currencyDisplayText",
          item-value="code",
          :loading="currencyLoading",
          v-model="instance.currency",
          :error-messages="errors['OrderLine.currency']",
        )
      //- Insert here
      v-col(cols="3")
        v-text-field(
          v-if="isCrossDock",
          :label="$t('OrderLine.consolidationKey')",
          :value="instance['consolidationKey']"
          @input="$store.commit(setInstancePathAction, { path: path + '.consolidationKey', value: $event })"
        )
    v-row
      v-col
        v-checkbox(
          v-model="instance.specificPickupTime",
          :value="!!instance.specificPickupTime",
          @change="setSpecific($event, 'specificPickupTime')",
          :label="$t('OrderLine.specificPickupTime')",
        )
      v-col
        app-datetime-picker(
          :disableTime="disablePickupTime",
          :textFieldProps="{ 'error-messages': errors['orderLine.datePickupFrom'] }"
          :label="$t('OrderLine.datePickupFrom')",
          :value="instance.datePickupFrom",
          @input="setDates($event, 'datePickupFrom')",
          v-bind="{tz}"
        )
      v-col
        app-datetime-picker(
          v-if="instance.specificPickupTime",
          :disableTime="disablePickupTime",
          :textFieldProps="{ 'error-messages': errors['orderLine.datePickupTo'] }",
          :label="$t('OrderLine.datePickupTo')",
          :value="instance.datePickupTo",
          @input="setDates($event, 'datePickupTo')"
          v-bind="{tz}"
        )
      v-col
        v-checkbox(
          v-model="instance.specificDeliveryTime",
          :value="!!instance.specificDeliveryTime",
          @change="setSpecific($event, 'specificDeliveryTime')",
          :label="$t('OrderLine.specificDeliveryTime')",
        )
      v-col
        app-datetime-picker(
          :disableTime="disableDeliveryTime",
          :textFieldProps="{ 'error-messages': errors['orderLine.dateDeliveryFrom'] }",
          :label="$t('OrderLine.dateDeliveryFrom')",
          :value="instance.dateDeliveryFrom",
          @input="setDates($event, 'dateDeliveryFrom')"
          v-bind="{tz}"
        )
      v-col
        app-datetime-picker(
          v-if="instance.specificDeliveryTime",
          :disableTime="disableDeliveryTime",
          :textFieldProps="{ 'error-messages': errors['orderLine.dateDeliveryFrom'] }",
          :label="$t('OrderLine.dateDeliveryTo')",
          :value="instance.dateDeliveryTo",
          @input="setDates($event, 'dateDeliveryTo')"
          v-bind="{tz}"
        )
  template(v-slot:unitType)
    v-select(
      :label="$t('OrderLine.unitType')",
      :value="instance.unitType",
      @input="$store.commit(setInstancePathAction, { path: path + '.unitType', value: $event })",
      :items="handlingUnitsList",
      item-text='name',
      item-value='name',
    )
</template>
<script>
import EntityMixin from '@/mixins';
import EntitiesMixin from '@/mixins/entities.mixin';
import axios from 'axios';

export default {
  mixins: [EntityMixin,EntitiesMixin],
  props: {
    chips: {
      type: Boolean,
      default: true
    },
    entity: {
      type: Object,
      default: () => ({}),
    },
    parent: {
      type: Object,
      default: () => ({})
    },
    parentInstance: {
      type: Object,
      default: () => ({})
    },
    path: {
      type: String,
      default: null,
    },
    ignoreFields: {
      type: Array,
      default: () => [
        "datePickupFrom",
        "datePickupTo",
        "dateDeliveryFrom",
        "dateDeliveryTo",
        "specificPickupTime",
        "specificDeliveryTime"
      ]
    },
    extraData: null,
    fromList: null,
  },
  data: function () {
    return {
      currencies: [],
      currencyLoading: true,
      status: null,
      timeZone: "",
      errors: [],
      lineInstance: {},
      handlingUnitsList: [],
      statusList: [],
    }
  },
  watch: {
    status: {
      handler(n, o) {
        if (n != null)
          this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: { ...this.instance, status: null, statusId: n.id } });
        else
          this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: { ...this.instance, status: null, statusId: null } });
      }
    }
    // lineInstance: {
    //   deep: true,
    //   handler(n, o) { // new and old
    //     console.log(`updating order line: ${this.path}`, { ...n })
    //     this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: { ...n }})
    //   }
    // }
  },
  methods: {
    setSpecific(value, key) {
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: { ...this.instance, [key]: !!value } });
    },
    setDates(value, key) {
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: { ...this.instance, [key]: value } });
    },
    async initializeCurrencies() {
      this.currencyLoading = true;
      this.currencies = await this.loadCurrencies();
      this.currencyLoading = false;
    },
  },
  computed: {
    disablePickupTime() {
      return !this.instance.specificPickupTime;
    },
    disableDeliveryTime() {
      return !this.instance.specificDeliveryTime;
    },
    tz() {
      return _.get(this.$store.state, 'instance.order.ianaTimeZone', '');
    },
    isCrossDock() {
      return localStorage.getItem('GEODIS').toLowerCase().includes('crossdock');
    },
  },
  async created() {
    this.initializeCurrencies();
    this.status = this.instance.status;
    this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: { ...this.instance, status: null } });
    this.handlingUnitsList = (await axios.get('HandlingUnit?Where[]=h => h.Entity.Contains("OrderLine") || h.Entity = null', { params: { pageSize: -1 } })).data.data;
    this.statusList = (await axios.get('Status?Where[]=entity = "OrderLine"', { params: { pageSize: -1 } })).data.data;
  },
}
</script>